'use client'
import { useState } from 'react';
import { motion } from 'framer-motion';
import s from './Legal.module.scss';
import { PortableText } from '@portabletext/react';
import { portableBlockComponents } from '@/utils/portableText';


export default function LegalComponent({ data }: any) {
    return (
        <div className={s.legalPage}>
            <div className={s.title}>
                <h1>{data.title}</h1>
            </div>
            <div className={s.content}>
                {data.body && data.body.map((item: any, index: number) => {
                    return (
                            <motion.div 
                                key={`legal-${index}`} 
                                className={s.block}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            > 
                                {item.content &&
                                    <PortableText
                                        value={item.content}
                                        components={portableBlockComponents(item.content)}
                                    />
                                }
                            </motion.div>
                        );
                })}
            </div>
        </div>
    );
}